import React, { useEffect } from "react";
import BackButton from "./BackButton";

const Description = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="description">
      <div className="title">Qui sommes-nous ?</div>
      <div>
        <div className="mb-4">
          Notre besoin est de créer, diffuser, développer et valoriser des
          outils de réflexion ou artistiques nous permettant de proposer une
          alternative non-violente et humaniste aux rapports de domination.
        </div>
        <div className="mb-4">
          Notre maison d’édition s’appuie sur un collectif de réflexion et de
          travail d’une quinzaine de femmes. Notre objectif est de créer et
          travailler dans le dialogue, l’échange, l’authenticité, le respect et
          le partage. En nous appuyant sur des compétences artistiques et
          intellectuelles diverses, mais aussi sur les cultures, vécus et
          parcours divers, nous reconnaissons à la fois entre nous les blessures
          que nous portons et celles que nous avons infligées, par manque de
          conscience, de cœur, de sécurité intérieure ou de connaissance. Nous
          avons été dominé.e.s en raison de ce que l’on est ou a été. Nous
          souhaitions, dès la fondation du projet, être plusieurs et être
          diverses.{" "}
        </div>
        <div className="mb-4">
          FarOuche * ÉditiOns a été créée par l’auteure et psychologue Ariane
          Calvo en mai 2020, au sortir du confinement qui a plongé dans la
          réflexion et l’intériorité la presque totalité de la planète.
          Soudainement, de façon imprévisible, nous avons été mises face à
          nous-mêmes et au sens que nous souhaitions donner à nos vies,
          individuellement et collectivement. Quand nous en sommes sorties, le
          25 mai 2020, lors d’un contrôle de police à Minneapolis (Minnesota),
          George Floyd est mort, tué parce qu’il était noir, sous le genou d’un
          policier blanc qui ne l’a pas laissé reprendre sa respiration jusqu’à
          ce qu’il meure. Nous avons appris qu’au cours de son agonie, il avait
          appelé sa mère à plusieurs reprises. “Momma, I’m through” (Maman, je
          suis mort).{" "}
        </div>
        <div className="mb-4">
          La prise de conscience fulgurante et insupportable qui s’en est suivie
          est celle de vivre dans un monde où des individus peuvent être coupés
          de toute empathie au point de laisser mourir sous leur genou une
          personne qui appelle sa maman, qui se voit mourir, sans que cet
          individu ne déplace son genou d’un centimètre. Nous ne pouvions plus
          rester assises sans rien faire, ou si peu.{" "}
        </div>
        <div className="mb-4">
          Nous voulons nous déplacer d’un centimètre et même de mille. Nous
          pensons qu’ensemble nous pouvons combler les distances quii nous
          éloignent les uns et les unes des autres, chacun et chacune de notre
          “Autre”, là où nous sommes, et à l’autre bout du monde. Nous avons
          pris conscience que toutes les formes de domination (qu’elle concerne
          les genres, les origines, les classes sociales, les sexualités, les
          morphologies, l’éducation, l’écologie, les animaux les handicaps, les
          peuples premiers) participent d’un même système : ceux qui dominent le
          font par peur de perdre leur pouvoir, croyant que c’est lui qui leur
          assure la vie, voire la survie. La mise en place de ce système est
          insupportable pour ceux qui le subissent en raison de leur fragilité
          ou de leur différence, alors qu’ils et elles aspirent à l’égalité et à
          l’émancipation. Ceux qui se sont attribués des privilèges, forçant
          d’autres à y renoncer peuvent, par la conviction de l’injustice,
          commencer à changer le système. Mais c’est aux personnes opprimées de
          faire connaître l’oppression et d’en dénoncer la violence. Nous
          voulons changer ce monde par l’action réflexive, collaborative,
          diverse, non-violente, inclusive, dans une proposition au monde,
          visant à œuvrer pour avancer vers un monde plus juste, plus ouvert,
          plus doux et plus tendre, plus pleinement vivant. A la suite du
          penseur Satish Kurma, nous pensons que Je suis Toi, et que Tu es Moi,
          que nous sommes tous connectés et reliés d’une façon mystérieuse et
          profonde. Ainsi, quand je fais un pas, tu bouges aussi, parfois
          imperceptiblement, mais cela suffit à rassasier un peu notre soif de
          justice et de paix.
        </div>
      </div>
      <BackButton />
    </div>
  );
};

export default Description;
